<div>
  <input type="text" class="form-control" (blur)="onBlur()" [(ngModel)]="userModel" (ngModelChange)="addUser()"
  [ngbTypeahead]="search" [inputFormatter]="formatter" [resultFormatter]="formatter" [editable]='false' />
</div>